function verifyTarget(t){return t.startsWith("_")?t:"_".concat(t)}export{verifyTarget as v};